import { StringHelper } from './stringHelper';
import { TimeSlot } from '../model/timeSlot';
import { Log } from '../util/log';

export class TimeSlotHelper {

  public static timeSlotsToBinaryString(timeSlotArray: TimeSlot[]) {

    let timeMask: string = "000000000000000000000000000000000000000000000000";

    if (timeSlotArray.length > 0) {

      for (let i = 0; i < timeSlotArray.length; i++) {

        let timeSlotMask = TimeSlotHelper.timeSlotToBinaryString(timeSlotArray[i]);

        for (let j = 0; j < 48; j++) {

          if (timeSlotMask.charAt(j) == "1") {

            timeMask = StringHelper.replaceAt(timeMask, j, "1");
          }
        }
      }

    } else {

      timeMask = "111111111111111111111111111111111111111111111111";
    }

    return timeMask;
  }

  public static binaryStringToTimeSlots(binaryString: string) {

    let timeSlots: TimeSlot[] = [];

    if (!binaryString) {
      return timeSlots;
    }

    let notSet: boolean = true;
    let startTime: number = 0;
    let endTime: number = 0;

    for (let i = 0; i < binaryString.length; i++) {

      if (binaryString.charAt(i) == "1") {

        if (notSet || startTime > i) {
          startTime = i;
          notSet = false;
        }
        if (endTime <= i) {
          endTime = i + 1;
        }

      } else if (!notSet) {

        // creo il timeslot

        let fromHour: number;
        let fromMinutes: number;
        let toHour: number;
        let toMinutes: number;

        if ((startTime % 2) == 0) {
          fromHour = (startTime / 2) | 0;
          fromMinutes = 0;
        } else {
          fromHour = (startTime / 2) | 0;
          fromMinutes = 30;
        }
        if ((endTime % 2) == 0) {
          toHour = (endTime / 2) | 0;
          toMinutes = 0;
        } else {
          toHour = (endTime / 2) | 0;
          toMinutes = 30;
        }

        timeSlots.push(new TimeSlot(fromHour, fromMinutes, toHour, toMinutes));

        startTime = 0;
        endTime = 0;
        notSet = true;
      }
    }

    return timeSlots;
  }

  public static binaryStringToTimeSlots5min(binaryString: string) {
    let timeSlots: TimeSlot[] = [];

    if (!binaryString) {
      return timeSlots;
    }

    let notSet: boolean = true;
    let startTime: number = 0;
    let endTime: number = 0;

    for (let i = 0; i < binaryString.length; i++) {

      if (binaryString.charAt(i) == "1") {

        if (notSet || startTime > i) {
          startTime = i;
          notSet = false;
        }
        if (endTime <= i) {
          endTime = i + 1;
        }

      } else if (!notSet) {

        // creo il timeslot

        let fromHour: number;
        let fromMinutes: number;
        let toHour: number;
        let toMinutes: number;

        fromHour = Math.floor(startTime / 12);
        fromMinutes = (startTime % 12) * 5;
        toHour = Math.floor(endTime / 12);
        toMinutes = (endTime % 12) * 5;

        timeSlots.push(new TimeSlot(fromHour, fromMinutes, toHour, toMinutes));

        startTime = 0;
        endTime = 0;
        notSet = true;
      }
    }

    if (!notSet) {
      // creo il timeslot

      endTime = 288;

      let fromHour: number;
      let fromMinutes: number;
      let toHour: number;
      let toMinutes: number;


      fromHour = Math.floor(startTime / 12);
      fromMinutes = (startTime % 12) * 5;
      toHour = Math.floor(endTime / 12);
      toMinutes = (endTime % 12) * 5;

      timeSlots.push(new TimeSlot(fromHour, fromMinutes, toHour, toMinutes));
    }/*  */

    return timeSlots;
  }


  public static binaryStringToTimeSlots10min(binaryString: string) {

    let timeSlots: TimeSlot[] = [];

    if (!binaryString) {
      return timeSlots;
    }


    if (binaryString == "11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111") {
      return timeSlots;
    }


    let notSet: boolean = true;
    let startTime: number = 0;
    let endTime: number = 0;

    for (let i = 0; i < binaryString.length; i++) {

      if (binaryString.charAt(i) == "1") {

        if (notSet || startTime > i) {
          startTime = i;
          notSet = false;
        }
        if (endTime <= i) {
          endTime = i + 1;
        }

      } else if (!notSet) {

        // creo il timeslot

        let fromHour: number;
        let fromMinutes: number;
        let toHour: number;
        let toMinutes: number;

        fromHour = Math.floor(startTime / 6);
        fromMinutes = (startTime % 6) * 10;
        toHour = Math.floor(endTime / 6);
        toMinutes = (endTime % 6) * 10;

        timeSlots.push(new TimeSlot(fromHour, fromMinutes, toHour, toMinutes));

        startTime = 0;
        endTime = 0;
        notSet = true;
      }
    }

    if (!notSet) {
      // creo il timeslot

      endTime = 144;

      let fromHour: number;
      let fromMinutes: number;
      let toHour: number;
      let toMinutes: number;


      fromHour = Math.floor(startTime / 6);
      fromMinutes = (startTime % 6) * 10;
      toHour = Math.floor(endTime / 6);
      toMinutes = (endTime % 6) * 10;

      timeSlots.push(new TimeSlot(fromHour, fromMinutes, toHour, toMinutes));
    }/*  */

    return timeSlots;
  }


  public static timeSlotToBinaryString(timeSlot: TimeSlot) {

    // considerando i minuti possibili: 0 e 30
    // la lunghezza della maschera raddoppia

    let startTime: number = timeSlot.fromHour * 2;
    if (timeSlot.fromMinutes == 30) {
      startTime++;
    }

    // devo sottrarre 30 minuti
    let endTime: number = timeSlot.toHour * 2;
    if (timeSlot.toMinutes == 0) {
      endTime--;
    }

    let mask: string = "000000000000000000000000000000000000000000000000";

    for (let i: number = startTime; i <= endTime; i++) {
      mask = StringHelper.replaceAt(mask, i, "1");
    }

    // var reversedMask = "";
    // for (var i = mask.length - 1; i >= 0; i--) {
    //   reversedMask += mask[i];
    // }

    return mask;
  }

  public static timeSlot5MinToBinaryString(timeSlot: TimeSlot) {

    let startTime: number = timeSlot.fromHour * 12;
    startTime += Math.ceil(timeSlot.fromMinutes / 5.0);

    // devo sottrarre 5 minuti
    let endTime: number = timeSlot.toHour * 12;
    endTime += Math.ceil(timeSlot.toMinutes / 5.0);
    // if (timeSlot.toMinutes == 0) {
    endTime--;
    // }

    let mask: string = "000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

    for (let i: number = startTime; i <= endTime; i++) {
      mask = StringHelper.replaceAt(mask, i, "1");
    }

    return mask;
  }


  public static timeSlot10MinToBinaryString(timeSlot: TimeSlot) {

    let startTime: number = timeSlot.fromHour * 6;
    startTime += Math.ceil(timeSlot.fromMinutes / 10.0);

    // devo sottrarre 5 minuti
    let endTime: number = timeSlot.toHour * 6;
    endTime += Math.ceil(timeSlot.toMinutes / 10.0);
    // if (timeSlot.toMinutes == 0) {
    endTime--;
    // }

    let mask: string = "000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

    for (let i: number = startTime; i <= endTime; i++) {
      mask = StringHelper.replaceAt(mask, i, "1");
    }

    return mask;
  }

}

